// src/components/QuizHistory.jsx
import React from "react";

export function QuizHistory({
  history,
  filter,
  onFilter,
  page,
  pageSize,
  onPageChange,
}) {
  // Filter and paginate
  const filtered = filter === "All"
    ? history
    : history.filter((h) => h.quiz_name === filter);
  const totalPages = Math.ceil(filtered.length / pageSize);
  const pageItems = filtered.slice((page - 1) * pageSize, page * pageSize);

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-md space-y-6">
      <h2 className="text-xl font-semibold text-gray-700">Quiz History</h2>

      {/* Filter */}
      <div className="flex items-center space-x-2">
        <label className="font-medium text-gray-700">Filter by Quiz:</label>
        <select
          value={filter}
          onChange={(e) => onFilter(e.target.value)}
          className="border px-3 py-1 rounded focus:outline-none focus:ring-2 focus:ring-indigo-400"
        >
          <option value="All">All</option>
          {[...new Set(history.map((h) => h.quiz_name))].map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>

      {/* History Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
          <thead className="bg-gray-200 text-left">
            <tr>
              <th className="border px-4 py-2">Quiz</th>
              <th className="border px-4 py-2">Score</th>
              <th className="border px-4 py-2">Date</th>
            </tr>
          </thead>
          <tbody className="bg-white even:bg-gray-50">
            {pageItems.map((h, i) => (
              <tr key={i}>
                <td className="border px-4 py-2">{h.quiz_name}</td>
                <td className="border px-4 py-2">
                  {h.score} / {h.total} (
                  {((h.score / h.total) * 100).toFixed(1)}%)
                </td>
                <td className="border px-4 py-2">
                  {new Date(h.timestamp).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-center items-center space-x-2">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
        >
          Prev
        </button>
        <span className="text-sm font-medium">
          Page {page} of {totalPages}
        </span>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}
